export const DisbursementValues = ["Disbursement Setup Pending", "Disbursement Setup Complete"] as const;
export type Disbursement = typeof DisbursementValues[number];